import EditButton from "components/EditButton";
import { useGetHierarchies } from "../hooks/useGetHierarchies";
import ReactTooltip from "react-tooltip";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { permissionsSelector } from "modules/Login/selectors/permissionSelector";
import { PERMISSIONS } from "modules/PermissionsConstants";
import { useEffect, useRef, useState } from "react";
import MaterialTableEmp from "components/tables/MaterialTableEmp";
import {
  hierarchyFormModalState,
  hierarchyIds,
  hierarchyShowState,
  hierarchyTypeModalState,
  hierarchyTypeState,
  isAddHierarchy,
  isEditHierarchy,
  rowForEditHierarchy,
  showHierarchyTable,
} from "../atoms/atoms";
import { Flex } from "components/layouts";
import { FunnelIcon, MapIcon } from "@heroicons/react/24/solid";
import AddButton from "components/AddButton";
import { Button } from "../../../../components/buttons";
import { toast } from "components/toastNotification";
import DownloadButton from "components/DownloadButton";
import { CSVLink } from "react-csv";
import { HierarchyTypeModal } from "../modals/HierarchyTypeModal";
import { HierarchyFormModal } from "../modals/HierarchyFormModal";
import HierarchyForm from "../forms/HierarchyForm";
import HierarchyView from "./HierarchyView";
import { useHistory, useLocation } from "react-router-dom";
import { mainSelectedTab } from "modules/CarrierAgreementMgmt/atoms";
import ConfirmBoxDelete from "components/ConfirmBoxDelete";
import useDeactivateHierarchies from "../hooks/useDeactivateHierarchies";
import { useQueryClient } from "react-query";
import { EmployeeTabs } from "modules/EmployeeTab/EmployeeTab";
import TableFilter from "../TableFilter";
import ViewOHButton from "components/buttons/ViewOHButton";
import useSendHierarchyEmail from "../hooks/useSendHierarchyEmail";
import SplcHierarchyOrgChart from "./HierarchyOrgChart/SPLC";

const HierarchyTable = ({
  filterHierchies,
  setFilteredData,
  filteredData,
  setFilterStatus,
  filterStatus,
  filterLoading,
}) => {
  //#region Data states
  const { data: hierarchies, isFetching } = useGetHierarchies();
  const {
    mutate: bulkDeleteHierarchies,
    isSuccess: deactivateSuccess,
    data: deactivateResult,
    reset: resetDeactivateData,
  } = useDeactivateHierarchies();
  const [hierarchyId, setHierarchyId] = useRecoilState(hierarchyIds);
  const setRowForEdit = useSetRecoilState(rowForEditHierarchy);
  const [filteredHierarchies, setFilteredHierarchies] = useState();
  const [filter, setFilter] = useState(false);

  //#endregion

  //#region Download states
  const [exportHierarchyData, setExportHierarchyData] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  //#endregion

  const [isAddState, setIsAddState] = useRecoilState(isAddHierarchy);
  const [isEditState, setIsEditState] = useRecoilState(isEditHierarchy);
  const [selectedRowsToDelete, setSelectedRowsToDelete] = useState<any>();
  const [openModalDelete, setOpenModalDelete] = useState(false);

  const [showHierarchyFormModalState, setShowHierarchyFormModalState] =
    useRecoilState(hierarchyFormModalState); //For show form modal
  const [showHierarchyTypeModal, setShowHierarchyTypeModal] = useRecoilState(
    hierarchyTypeModalState
  ); // For show type of hierarchy modal
  const [hierarchyType, setHierarchyType] = useRecoilState(hierarchyTypeState); //For hierarchy type value
  const [tableShow, setTableShow] = useRecoilState(showHierarchyTable);
  const [, setOrgChartShow] = useState(true);

  const [selectedRows] = useState([]);
  const tableRef = useRef<any>();
  const history = useHistory();
  let location = useLocation();
  const queryClient = useQueryClient();

  const setSelectedIndex = useSetRecoilState(mainSelectedTab);
  const [isParent, setIsParent] = useState(false);
  const [showState, setShowState] = useRecoilState(hierarchyShowState);

  const { mutateAsync: sendHierarchyEmail } = useSendHierarchyEmail();

  //#region Permissions
  const userPermissions = useRecoilValue(permissionsSelector);
  const addPermission = PERMISSIONS.permission_hierarchy_add;
  const deletePermission = PERMISSIONS.permission_hierarchy_delete;
  const editPermission = PERMISSIONS.permission_hierarchy_update;
  const employeeViewPermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_employee_view;
  //#endregion

  let recordIdFromRecent;
  if (location.state != null) {
    recordIdFromRecent = location.state;
  }

  //#region useEffect Redirection
  useEffect(() => {
    if (!recordIdFromRecent) return;

    const { action, moduleName, hierarchyId, splcHierarchyId, recordId } =
      recordIdFromRecent;

    const handleRedirectToHierarchy = () => {
      setHierarchyId(hierarchyId);
      setShowState(true);
    };

    const handleOfficeToSplcHierarchy = () => {
      const splcData = hierarchies?.filter(
        (x) => x.hierarchyId === splcHierarchyId
      );
      onclickHierarchyName(splcData, false);
      setHierarchyId(splcHierarchyId);
      setTableShow(true);
    };

    const handleHierarchyModule = () => {
      setTableShow(true);

      if (recordId?.toString()?.includes(".")) {
        const hierarchyIds = recordId.toString().split(".").map(Number);
        const filteredData = hierarchies?.filter((x) =>
          hierarchyIds.includes(x.hierarchyId)
        );
        setFilteredHierarchies(filteredData);
      } else {
        const hierarchyData = hierarchies?.filter(
          (x) => x.hierarchyId === recordId
        );
        onclickHierarchyName(hierarchyData, false);
        setHierarchyId(recordId);
        setShowState(true);
      }
    };

    switch (action) {
      case "RedirectToHierarchy":
        handleRedirectToHierarchy();
        break;
      case "OfficeToSplcHierarchy":
        handleOfficeToSplcHierarchy();
        break;
      case "RedirectToHierarchyTable":
        // currently does nothing
        break;
      default:
        if (moduleName === "Hierarchy") {
          handleHierarchyModule();
        }
        break;
    }
  }, [hierarchies, recordIdFromRecent]);

  useEffect(() => {
    setTableShow(
      recordIdFromRecent?.action === "RedirectToHierarchyTable" ? true : false
    );
  }, []);

  if (recordIdFromRecent?.action === "RedirectToHierarchyNsa") {
    if (!isFetching) {
      setTimeout(() => {
        history.replace("/employeetab/hierarchy");
      }, 2000);
    }
  }
  if (recordIdFromRecent?.action === "RedirectToHierarchySplc") {
    if (!isFetching) {
      setTimeout(() => {
        history.replace("/employeetab/hierarchy/splc");
      }, 2000);
    }
  }
  //#endregion

  const alignCenter = "center" as
    | "center"
    | "inherit"
    | "justify"
    | "left"
    | "right"
    | undefined;

  const onclickHierarchyName = (rowData, isParent = false) => {
    setShowState(true);
    setHierarchyId(rowData?.hierarchyId);
    setIsParent(isParent);
  };

  const onClickEmployee = (employeeId, data) => {
    const url = "/employeetab/employee";
    history.push({
      pathname: url,
      state: {
        hierarchyId: data.hierarchyId,
        employeeId: employeeId,
        actionToManager: "FromHierarchyTable",
      },
    });

    let userTabs = [
      {
        to: "",
      },
    ];
    [...EmployeeTabs].forEach((tabs) => {
      let temp = [...userPermissions].filter(
        (user) => user === tabs.permission
      );
      if (temp.length > 0)
        userTabs.push({
          to: tabs.to,
        });
    });
    userTabs.shift();
    const index = userTabs.findIndex((c) => c.to === url);
    setSelectedIndex(index);
  };

  //#region Handle Edit
  const handleEdit = (rowDetails) => {
    queryClient.removeQueries("GetHierarchyEmployeeOpts");
    setRowForEdit({
      ...rowDetails,
      managerEffectiveDate:
        rowDetails?.managerEffectiveDate !== null
          ? new Date(rowDetails.managerEffectiveDate)
              .toISOString()
              .split("T")[0]
          : rowDetails?.managerEffectiveDate,
    });
    setShowHierarchyFormModalState(true);
  };
  //#endregion

  //#region Table columns
  const columns = [
    {
      title: "Hierarchy Name",
      field: "hierarchyName",
      customSort: (a, b) => {
        // Handle null/undefined
        const hierarchyNameA = a.hierarchyName?.toLowerCase() || "";
        const hierarchyNameB = b.hierarchyName?.toLowerCase() || "";

        // If hierarchyName is empty, consider it as the smallest value (comes last in descending order)
        if (hierarchyNameA > hierarchyNameB) return 1;
        if (hierarchyNameA < hierarchyNameB) return -1;
        return 0;
      },
      render: (rowdata) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => {
              onclickHierarchyName(rowdata);
            }}
          >
            <span className="blueAndBold underline">
              {rowdata.hierarchyName}
            </span>
          </div>
        );
      },
    },
    {
      title: "Hierarchy Type",
      field: "hierarchyTypeName",
    },
    {
      title: "Manager",
      field: "employeeName",
      render: (rowdata) => {
        return (
          <div>
            <ReactTooltip place="right" effect="solid" type="info" />
            {userPermissions.includes(employeeViewPermission) ? (
              rowdata.employeeName !== "" ? (
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    onClickEmployee(rowdata.employeeId, rowdata);
                  }}
                >
                  <span className="blueAndBold underline">
                    {rowdata.employeeName}
                  </span>
                </div>
              ) : (
                rowdata.employeeName
              )
            ) : (
              <div
                data-tip={
                  "Contact your System Administrator to secure access to employee module."
                }
                className="cursor-pointer"
              >
                {rowdata.employeeName}
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "Status",
      field: "isActive",
      render: (rowData) => {
        return <div>{rowData.isActive ? "Active" : "Inactive"}</div>;
      },
      customFilterAndSearch: (term, rowData) => {
        // Handle case-insensitivity
        const searchTerm = term.toLowerCase();

        // Return true if search matches "active" or "inactive"
        if (searchTerm === "active" && rowData.isActive) return true;
        if (searchTerm === "inactive" && !rowData.isActive) return true;

        return false;
      },
    },
    {
      title: "Action",
      sorting: false,
      align: alignCenter,
      render: (rowDetails) => {
        return (
          userPermissions.includes(editPermission) && (
            <div className="flex place-content-center">
              <EditButton
                className={
                  selectedRows.length > 0 ? "opacity-50" : "opacity-100"
                }
                disabled={selectedRows.length > 0 ? true : false}
                buttonText="Edit"
                onClick={() => {
                  setHierarchyId(rowDetails.hierarchyId);
                  setIsEditState(true);
                  handleEdit(rowDetails);
                }}
              />
            </div>
          )
        );
      },
    },
  ];
  //#endregion

  //#region Downaload Hierarchy

  const mapExportData = (exportData) => {
    if (exportData) {
      setExportHierarchyData(
        exportData?.map((x) => {
          const fullTeamName = [
            x?.businessUnitHierarchyName,
            x?.marketHierarchyName,
            x?.stateHierarchyName,
            x?.districtHierarchyName,
            x?.teamHierarchyName,
          ]
            .filter(Boolean)
            .join("_");
          // eslint-disable-next-line no-lone-blocks
          {
            return {
              HierarchyName: x.hierarchyName,
              HierarchyTypeName: x.hierarchyTypeName,
              "Team Name": x.hierarchyTypeName === "Team" ? fullTeamName : "",
              Manager: x.employeeName,
              Phone: x.phone,
              Email: x.email,
              "Team Manager": x.teamManagerEmployeeName,
              "Team Hierarchy": x.teamHierarchyName,
              "District Manager": x.districtManagerEmployeeName,
              "District Hierarchy": x.districtHierarchyName,
              Director: x.directorEmployeeName,
              "State Hierarchy": x.stateHierarchyName,
              "Vice President": x.vicePresidentEmployeeName,
              "Market Hierarchy": x.marketHierarchyName,
              "Senior Vice President": x.seniorVicePresidentEmployeeName,
              "Business Unit Hierarchy": x.businessUnitHierarchyName,
              Description: x.description,
              IsActive: x.isActive,
              "SPLC Hierarchy": x.isSplcHierarchy,
              IsFranchise: x.isFranchise ? "True" : "False",
              "Created By": x.createdBy,
              "Created Date": x.createdDate
                ? new Date(x.createdDate)?.toLocaleDateString()
                : "",
              "Modified By": x.modifiedBy,
              "Modified Date": x.modifiedDate
                ? new Date(x.modifiedDate)?.toLocaleDateString()
                : "",
            };
          }
        })
      );
      setTimeout(() => {
        toast.fire(
          "Download SPLC Hierarchy Reports",
          "SPLC Hierarchy Reports downloaded successfully.",
          "success"
        );
        setIsDownloading(false);
      }, 2000);
    }
  };
  //#endregion

  //#region CSVReport
  let dateTimeToday = new Date(new Date().toISOString()).toISOString();
  const csvReport = {
    filename: "SPLCHierarchyReport" + dateTimeToday + ".csv",
    data: exportHierarchyData ? exportHierarchyData : [],
  };
  //#endregion

  //#region Deactivate
  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows
      .filter((x) => x.isActive)
      .map((r) => {
        const { tableData, ...rows } = r;
        return rows;
      });

    setSelectedRowsToDelete(forDelete?.map((x) => x.hierarchyId));
  };

  const handleBulkDelete = () => {
    const hierarchyIds = selectedRowsToDelete;
    bulkDeleteHierarchies(hierarchyIds);
    setOpenModalDelete(false);
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">
      {`Are you sure you want to deactivate ${selectedRowsToDelete?.length} ${
        selectedRowsToDelete
          ? selectedRowsToDelete?.length > 1
            ? "SPLC Hierarchies"
            : "SPLC Hierachy"
          : ""
      }?`}
    </div>
  );
  //#endregion

  //#region Deactivate Status
  useEffect(() => {
    if (deactivateSuccess && deactivateResult) {
      if (deactivateResult.status === 201 || deactivateResult.status === 200) {
        toast.fire(
          "Success",
          "SPLC Hierarchy were deactivated successfully",
          "success"
        );
        deactivateResult.data.forEach((item) => {
          sendHierarchyEmail(item);
        });
        queryClient.invalidateQueries("GetHierarchies");
        setSelectedRowsToDelete([]);
        resetDeactivateData();
      } else if (deactivateResult.status === 500) {
        if (
          deactivateResult.data.message ===
            "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available" ||
          deactivateResult.data.message ===
            "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available"
        ) {
          toast.fire(
            "Warning",
            "SPLC Hierarchy were successfully deactivated, but " +
              deactivateResult.data.message,
            "warning"
          );
          setSelectedRowsToDelete([]);
        } else {
          toast.fire(
            "Bulk deactivation of SPLC Hierarchy failed",
            "Server Error: Cannot deactivate SPLC Hierarchy",
            "error"
          );
        }
        queryClient.invalidateQueries("GetHierarchies");
      } else {
        toast.fire(
          "Bulk deactivation of SPLC Hierarchy failed",
          "Server Error: Cannot deactivate SPLC Hierarchy",
          "error"
        );
        queryClient.invalidateQueries("GetHierarchies");
      }
    }
  }, [deactivateResult, deactivateSuccess, queryClient, resetDeactivateData]);

  //#endregion

  //#region Cancel Show
  const onClickCancelShow = () => {
    if (recordIdFromRecent?.officeId) {
      const url = "/officesettings/officesetting";
      history.push({
        pathname: url,
        state: {
          officeId: recordIdFromRecent?.officeId,
          action: "FromSplcHierarchy",
        },
      });
      window.location.reload();
      let userTabs = [
        {
          to: "",
        },
      ];
      [...EmployeeTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0)
          userTabs.push({
            to: tabs.to,
          });
      });
      userTabs.shift();
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
    } else {
      history.replace({
        state: undefined,
      });
    }
    setShowState(false);
  };
  //#endregion
  return (
    <>
      <HierarchyTypeModal
        isOpen={showHierarchyTypeModal}
        onClose={() => {
          setShowHierarchyTypeModal(false);
        }}
      >
        <div>
          <Flex className="space-x-2 justify-end w-full">
            <Button
              variant="lightGray"
              type="button"
              size="sm"
              onClick={() => {
                setHierarchyType("");
                setShowHierarchyTypeModal(false);
              }}
            >
              Cancel
            </Button>
            <Button
              type="button"
              size="sm"
              disabled={hierarchyType ? false : true}
              onClick={() => {
                setIsAddState(true);
                setShowHierarchyTypeModal(false);
                setShowHierarchyFormModalState(true);
              }}
            >
              Next
            </Button>
          </Flex>
        </div>
      </HierarchyTypeModal>
      {showHierarchyFormModalState && (
        <HierarchyFormModal
          isOpen={showHierarchyFormModalState}
          hasCloseButton={false}
          width="4/5"
          className="border"
        >
          {showHierarchyFormModalState && (
            <HierarchyForm
              hierarchyData={hierarchies}
              isLoading={isFetching}
              setFilteredHierarchies={setFilteredHierarchies}
            />
          )}
        </HierarchyFormModal>
      )}
      {!showState && (
        <div className="pt-4 px-8 bg-white min-h-fit">
          <div>
            <div className="flex gap-2 items-center ml-5">
              <div>
                <MapIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
              </div>
              <div className="flex flex-col leading tight">
                <h3 className="text-xs font-medium text-gray-500">
                  SPLC Hierarchy
                </h3>
                <h1 className="mr-auto font-bold text-primary text-md uppercase">
                  All SPLC Hierarchy Information
                </h1>
              </div>
            </div>
          </div>
          <div className="flex flex-row gap-2 justify-between items-center ml-5">
            {userPermissions.includes(editPermission) && tableShow === true && (
              <div className="text-secondary italic text-xs3 my-2">
                <p className="font-bold italic inline-block mr-1">Note: </p>
                Tick the box to deactivate some data.
              </div>
            )}
          </div>
          <div className="text-xs  space-y-2">
            <div
              className={
                !tableShow
                  ? "pb-2 flex justify-end "
                  : "px-4 flex justify-between pb-2"
              }
            >
              {tableShow && (
                <div className="space-x-4 mr-6">
                  <button
                    className="hover:scale-90 transition duration-500 flex justify-center items-center shadow-md px-3 py-1 h-7 text-xs 
                  gap-x-2 font-semibold text-primary border hover:bg-primary selected hover:text-white border-primary rounded-md"
                    onClick={() => {
                      setFilter(!filter);
                    }}
                  >
                    <div>Filter By</div>
                    <FunnelIcon className="h-3 w-3 focus:bg-primary" />
                  </button>
                </div>
              )}
              <div className=" flex flex-row justify-between gap-2">
                {!tableShow ? (
                  <ViewOHButton
                    className={"opacity-100"}
                    disabled={false}
                    buttonText="View as Table"
                    onClick={() => {
                      setOrgChartShow(false);
                      setTableShow(true);
                      history.push("/employeetab/hierarchy");
                    }}
                  />
                ) : (
                  <ViewOHButton
                    className={"opacity-100"}
                    disabled={false}
                    buttonText="View as Organizational Chart"
                    onClick={() => {
                      setTableShow(false);
                      setOrgChartShow(true);
                      setFilteredHierarchies(undefined);
                    }}
                  />
                )}
                {userPermissions.includes(addPermission) && (
                  <AddButton
                    className={"opacity-100"}
                    disabled={false}
                    buttonText="Add"
                    onClick={() => {
                      setShowHierarchyTypeModal(true);
                    }}
                  />
                )}
                {!showState && !tableShow ? (
                  ""
                ) : (
                  <div>
                    <CSVLink {...csvReport}>
                      <DownloadButton
                        disabled={isDownloading ? true : false}
                        buttonValue={
                          isDownloading ? "Downloading..." : "Download File"
                        }
                        onClick={() => {
                          setIsDownloading(true);
                          mapExportData(
                            tableRef &&
                              tableRef.current.dataManager.searchedData.length >
                                0
                              ? tableRef.current.dataManager.searchedData
                              : hierarchies
                          );
                        }}
                      />
                    </CSVLink>
                  </div>
                )}
              </div>
            </div>
          </div>
          {!showState && !tableShow ? (
            <>
              <SplcHierarchyOrgChart />
            </>
          ) : (
            <main
              className={`${
                !showState ? "block" : "hidden"
              } flex justify-between mr-4`}
            >
              {filter && (
                <div className="overflow-y-auto flex-col flex-grow bg-white">
                  <div className="mb-4">
                    {!isFetching &&
                      !isAddState &&
                      !isEditState &&
                      !showState && (
                        <TableFilter
                          filterHierchies={filterHierchies}
                          setFilteredData={setFilteredData}
                          filter={filter}
                          hierarchyData={hierarchies}
                          setFilterStatus={setFilterStatus}
                        />
                      )}
                  </div>
                </div>
              )}
              <div className={`${filter ? "w-4/5" : "w-full p-4"}`}>
                <MaterialTableEmp
                  data={
                    filterStatus
                      ? filteredData
                      : filteredHierarchies
                      ? filteredHierarchies
                      : hierarchies
                  }
                  columns={columns}
                  isLoading={filterStatus ? filterLoading : isFetching}
                  searchFieldAlignment={"left"}
                  selectedRows={selectedRowsToDelete}
                  toolbar={true}
                  search={true}
                  showTitle={false}
                  tableRef={tableRef}
                  exportButton={false}
                  selection={userPermissions.includes(deletePermission)}
                  title={"SPLCHierarchy_" + new Date().toLocaleDateString()}
                  onSelectionChange={handleSelectedRowsChange}
                  setOpenModal={setOpenModalDelete}
                  actions={undefined}
                  editable={undefined}
                  grouping={undefined}
                  detailPanel={undefined}
                  toolBarComponent={undefined}
                  panelWidth={undefined}
                  onSearchChange={undefined}
                  fileName={undefined}
                  options={{
                    toolbar: false,
                    showTitle: false,
                    initialPage: 0,
                  }}
                />
              </div>
            </main>
          )}
        </div>
      )}

      {showState && (
        <HierarchyView
          hierarchyId={hierarchyId}
          isParent={isParent}
          onclickHierarchyName={onclickHierarchyName}
          hierarchyData={hierarchies}
          handleEdit={handleEdit}
          onClickCancelShow={onClickCancelShow}
        />
      )}
      <ConfirmBoxDelete
        ModalTitle="Deactivate SPLC Hierachy"
        qConfirmation={deleteMessage}
        isOpen={openModalDelete}
        onClose={() => setOpenModalDelete(false)}
        onClickFunction={handleBulkDelete}
        cancelButtonRef={undefined}
      />
    </>
  );
};
export default HierarchyTable;
